"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _slicedToArray = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _templateObject, _templateObject2, _templateObject3;

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importStar(require("react"));

var frontend_layout_1 = require("@ryerson/frontend.layout");

var react_2 = require("@emotion/react");

var styled_1 = __importDefault(require("@emotion/styled"));

var frontend_theme_1 = require("@ryerson/frontend.theme");

var Tabs = function Tabs(_ref) {
  var children = _ref.children,
      _ref$initialActiveTab = _ref.initialActiveTabIndex,
      initialActiveTabIndex = _ref$initialActiveTab === void 0 ? 0 : _ref$initialActiveTab,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? true : _ref$fullWidth,
      tabClicked = _ref.tabClicked,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "primary" : _ref$type,
      dataTestId = _ref.dataTestId;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var background = theme.colors[type].background;
  var wasClicked = react_1.default.useRef();
  var dividerColor;
  var dividerOpacity;

  switch (theme.colors[type].background) {
    case theme.colors.primary.white:
    case theme.colors.primary.lighterGray:
    case theme.colors.primary.lightGray:
      dividerColor = theme.colors.primary.darkerGray;
      dividerOpacity = 0.2;
      break;

    case theme.colors.primary.gray:
    case theme.colors.primary.darkGray:
    case theme.colors.primary.darkerGray:
      dividerColor = theme.colors.primary.white;
      dividerOpacity = 0.5;
      break;

    default:
      dividerColor = theme.colors.primary.white;
      dividerOpacity = 0.1;
  }

  var handleTabClick = function handleTabClick(tabIndex) {
    tabClicked && tabClicked(tabIndex);
    setActiveTabIndex(tabIndex);
  };

  var findHashInTabChildren = function findHashInTabChildren(hashString) {
    var indexFound;
    react_1.default.Children.forEach(children, function (tab, index) {
      var urlHash = tab.props.urlHash;

      if (!!urlHash) {
        !((urlHash === null || urlHash === void 0 ? void 0 : urlHash.indexOf("#")) >= 0) && (urlHash = "#" + urlHash);
        urlHash === hashString && (indexFound = index);
      }
    });
    return indexFound;
  };

  var getInitialTab = function getInitialTab() {
    var currWindowHash;
    var tabIndexFromUrlHash;

    if (typeof window !== "undefined") {
      currWindowHash = window.location.hash;
    }

    if (currWindowHash) {
      tabIndexFromUrlHash = findHashInTabChildren(currWindowHash);
    }

    if (typeof tabIndexFromUrlHash !== "undefined") {
      return tabIndexFromUrlHash;
    } else {
      return initialActiveTabIndex;
    }
  };

  var _ref3 = (0, react_1.useState)(getInitialTab),
      _ref4 = _slicedToArray(_ref3, 2),
      activeTabIndex = _ref4[0],
      setActiveTabIndex = _ref4[1];

  var constructTabs = function constructTabs() {
    return react_1.default.Children.map(children, function (tab, index) {
      return react_1.default.cloneElement(tab, {
        tabIndex: index,
        onClick: handleTabClick,
        isActive: index === activeTabIndex,
        type: type
      });
    });
  };

  var renderActiveTabPanel = function renderActiveTabPanel() {
    var _a;

    var activeTab = children[activeTabIndex];
    var itemHashProp = (_a = activeTab === null || activeTab === void 0 ? void 0 : activeTab.props) === null || _a === void 0 ? void 0 : _a.urlHash;

    if (activeTab) {
      //set url hash if applicable
      if (!!itemHashProp && wasClicked.current && typeof window !== "undefined") {
        window && (window.location.hash = itemHashProp);
      } // reset flags


      wasClicked.current = false;
      return activeTab.props.children;
    }
  };

  var Divider = styled_1.default.hr(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\tleft: 0;\n\t\tright: 0;\n\t\tborder: 0;\n\t\tmargin-top: 0;\n\t\theight: 1px;\n\t\tbackground-color: ", ";\n\t\topacity: ", ";\n\t\t", ";\n\t"])), dividerColor, dividerOpacity, function (props) {
    return (0, react_2.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t\t\tposition: ", ";\n\t\t\t"])), props.fullWidth ? "absolute" : "relative");
  });
  var Container = styled_1.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\t\tbackground-color: ", ";\n\t"])), background);
  var tabs = constructTabs();
  return (0, jsx_runtime_1.jsxs)(Container, {
    "data-testid": dataTestId,
    children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
      onClick: function onClick(e) {
        return wasClicked.current = true;
      },
      children: tabs.map(function (tab, index) {
        return (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
          children: tab
        }, index);
      })
    }), (0, jsx_runtime_1.jsx)(Divider, {
      fullWidth: fullWidth
    }), (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
      children: renderActiveTabPanel()
    })]
  });
};

exports.default = Tabs;